import React from 'react';
import SafeImage from '../SafeImage';
import { getOrganizerLogoSrc, DEFAULT_ORGANIZER_LOGO } from '../../lib/defaultBranding';

/**
 * EventSidebar — right-column sticky sidebar on the public Event page.
 * Pure presentational. Shows event_type, capacity summary, organizer logo,
 * and the "Powered by VelvetGate" footer.
 */
export default function EventSidebar({ event, availability }) {
  const { src: logoSrc, isDefault: logoIsDefault } = getOrganizerLogoSrc(event);
  // Unlimited events: backend returns -1 for total & remaining. Prefer the
  // explicit flag; fall back to event.is_unlimited_capacity for safety.
  const isUnlimited = !!(availability?.is_unlimited_capacity ?? event?.is_unlimited_capacity);
  const fmtTotal = isUnlimited ? '∞' : availability?.total_capacity;
  const fmtRemaining = isUnlimited
    ? '∞'
    : Math.max(0, Number(availability?.remaining_capacity ?? 0));
  return (
    <div className="bg-[#0A0A0A] border border-[#1A1A1A] rounded-sm p-6 sticky top-8">
      <div className="text-sm font-medium text-[#777] uppercase tracking-wide mb-2">Event Type</div>
      <div className="text-lg font-semibold text-[#EAE7E1] mb-6">{event.event_type}</div>
      {availability && (
        <div className="pt-4 border-t border-[#1A1A1A] mb-6">
          <div className="text-sm font-medium text-[#777] uppercase tracking-wide mb-3">Capacity</div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-[#AFAFAF]">Total Capacity</span><span className="font-medium text-[#EAE7E1]" data-testid="cap-total">{fmtTotal}</span></div>
            <div className="flex justify-between"><span className="text-[#AFAFAF]">Registered</span><span className="font-medium text-[#EAE7E1]" data-testid="cap-registered">{availability.attendees_registered}</span></div>
            <div className="flex justify-between"><span className="text-[#AFAFAF]">Remaining</span><span className="font-medium text-[#D4AF37]" data-testid="cap-remaining">{fmtRemaining}</span></div>
          </div>
        </div>
      )}
      {/* Organizer logo — host-specific when present, otherwise VelvetGate
          platform default. Transparent-corner PNG blends with dark bg. */}
      <div className="pt-4 border-t border-[#1A1A1A]">
        <div className="text-sm font-medium text-[#777] uppercase tracking-wide mb-3">Organized By</div>
        <SafeImage
          src={logoSrc}
          alt={logoIsDefault ? 'VelvetGate' : 'Organizer Logo'}
          className="h-16"
          imgClassName="object-contain h-16 w-auto"
          fallbackLabel="LOGO"
          fallbackClassName="h-16 w-24"
          fallbackSrc={logoIsDefault ? null : DEFAULT_ORGANIZER_LOGO}
          data-testid={logoIsDefault ? 'organizer-logo-default' : 'organizer-logo'}
        />
      </div>
      <div className="pt-4 mt-4 border-t border-[#1A1A1A] text-center">
        <span className="text-xs text-[#777] tracking-wider uppercase">Powered by</span>
        <div className="text-[#D4AF37] font-black text-lg tracking-tight mt-1">VelvetGate</div>
      </div>
    </div>
  );
}
